import { isoZ, z } from 'my-zod'
import { enumOptionsToObject } from '../../internal/enum-helpers'

const lifecycleStatusOptions = ['Draft', 'Published', 'Retired'] as const
const lifecycleStatuses = enumOptionsToObject(lifecycleStatusOptions)

const platformOptions = ['Polaris', 'Viator'] as const

const rentalProductModel = z.object({
  id: z.string().min(1).uuid(),
  versionId: z.number(),
  shortId: z.string().max(12),
  platform: z.enum(platformOptions),
  outfitterId: z.number(),
  lifecycleStatus: z.enum(lifecycleStatusOptions),
  title: z.string().min(3).max(128),
  waiverContentId: z.string().nullable(),
  taxPolicyIds: z.number().array(),
  createdDate: isoZ.instant(),
  lastModifiedDate: isoZ.instant()
})

export const RentalProductSchemas = {
  rentalProductModel,
  lifecycleStatuses,
  lifecycleStatusOptions,
  platformOptions
}

export declare namespace RentalProductSchemas {
  export type LifecycleStatus = (typeof lifecycleStatusOptions)[number]
  export type rentalProductModel = z.infer<typeof rentalProductModel>
}
